import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const GetBusinessDetail = createAsyncThunk('business/get-business-detail', async ( {id}, { getState, rejectWithValue }) => {
  const { loginToken } = getState();
  const authToken = loginToken?.response?.token;
  try {
    const response = await fetch(
      `${ROOT_URL}/business/get-business-detail/${id}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    const result = await response.json();
    return result;
  } catch (error) {
    return rejectWithValue(error.response);
  }
});

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
  hasLoadedOnce: false,
};

const ListUserIndividual = createSlice(
  {
    name: 'deleteGroup',
    initialState,
    reducers: {},
    extraReducers: {
      [GetBusinessDetail.pending]: (state) => {
        state.isLoading = !state.hasLoadedOnce;
      },
      [GetBusinessDetail.fulfilled]: (state, action) => {
        state.isLoading = false;
        state.hasLoadedOnce = true;
        state.isSuccess = true;
        state.isError = false;
        state.response = action.payload;
      },
      [GetBusinessDetail.rejected]: (state, action) => {
        state.isLoading = false;
        state.hasLoadedOnce = false;
        state.isSuccess = false;
        state.isError = true;
        state.error = action.payload;
      },
    },
  },
);

export default ListUserIndividual;
